import React from "react";
import ReactDOM from "react-dom/client";
import App from "./src/App";
import "./main.css";
import { ThemeProvider } from "@mui/material";
import THEME from "./src/utils/Theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();
ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={THEME}>
      <App />
    </ThemeProvider>
  </QueryClientProvider>
  // </React.StrictMode>
);
